// extracted by mini-css-extract-plugin
export default {"button":"VersionButton-module__button--FJsNh","icon":"VersionButton-module__icon--ei3xd","text":"VersionButton-module__text--XLBkS","safari":"VersionButton-module__safari--_ZTJj"};